import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import SidebarContainer from '../SidebarContainer';
import formsActions from '../../redux/forms/actions';
import ContentPage from '../ContentPage';
import ErrorMessage from '../../components/ErrorMessage';

import { FormEditor, NewForm } from '../../components/FormEditor';
import DealerNav from '../../components/DealerNav';

class Form extends Component {
  componentDidMount() {
    const { formId, dealerId } = this.props.match.params;
    if (formId) {
      this.props.actions.formRequest(formId);
    } else {
      this.props.actions.resetForm(dealerId);
    }
  }

  onCreate = (params) => {
    this.props.actions.createFormRequest(params);
  };

  onSave = (form) => {
    this.props.actions.updateFormRequest(form);
  };

  onEdit = (changes) => {
    this.props.actions.editFormRequest({
      formId: this.props.forms.form.id,
      changes,
    });
  };

  render() {
    const { forms, dealer } = this.props;
    const { form, error, fetching } = forms;

    return (
      <SidebarContainer title={dealer.name} logo={dealer.logo}>
        <div className="forms-table">
          {error && <ErrorMessage error={error} />}
          <DealerNav />
          {form.id && (
            <FormEditor
              form={form}
              fetching={fetching}
              onSave={this.onSave}
              onEdit={this.onEdit}
            />
          )}
          {!form.id && (
            <NewForm form={form} fetching={fetching} onCreate={this.onCreate} />
          )}
        </div>
      </SidebarContainer>
    );
  }
}

Form.propTypes = {
  match: PropTypes.object,
  actions: PropTypes.object,
  forms: PropTypes.object,
  dealer: PropTypes.object,
};

const mapStateToProps = ({ forms, dealers }) => ({
  forms,
  dealer: dealers.dealer,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(formsActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentPage(Form));
